import {
  OPEN_ADMIN_ROLES_MODAL,
  CLOSE_ADMIN_ROLES_MODAL,
  OPEN_ADMIN_USER_MODAL,
  CLOSE_ADMIN_USER_MODAL,
  OPEN_HEADER_MODAL,
  CLOSE_HEADER_MODAL,
  EDIT_BOOKING_MODAL,
  CANCEL_BOOKING_MODAL,
  OPEN_CURRENCY_MODAL,
  IMAGE_LIGHTBOX_OPEN,
  IMAGE_LIGHTBOX_CLOSE,
  OPEN_DESCRIPTION_MODAL,
  CLOSE_DESCRIPTION_MODAL,
  CANCEL_SCHEDULED_BOOKING_MODAL,
  OPEN_SCHEDULED_BOOKING_MODAL,
  CLOSE_SCHEDULED_BOOKING_MODAL,
  OPEN_BASE_FARE_MODAL,
  CLOSE_BASE_FARE_MODAL,
  TOGGLE_ADMIN_MENU,
  OPEN_PROVIDER_APPROVAL_MODAL,
  CLOSE_PROVIDER_APPROVAL_MODAL
} from '../constants';

export default function modalReducer(state = {}, action) {
  switch (action.type) {
    case OPEN_ADMIN_ROLES_MODAL:
      return {
        ...state,
        adminRolesModal: action.payload.adminRolesModal,
        adminRolesModalType: action.payload.adminRolesModalType
      };

    case CLOSE_ADMIN_ROLES_MODAL:
      return {
        ...state,
        adminRolesModal: action.payload.adminRolesModal,
        adminRolesModalType: null
      };

    case OPEN_ADMIN_USER_MODAL:
      return {
        ...state,
        adminUserModal: action.payload.adminUserModal,
        adminUserModalType: action.payload.adminUserModalType
      };

    case CLOSE_ADMIN_USER_MODAL:
      return {
        ...state,
        adminUserModal: action.payload.adminUserModal,
        adminUserModalType: null
      };

    case OPEN_HEADER_MODAL:
      return {
        ...state,
        [action.payload.modalType]: action.payload.actionValue,
        formData: action.payload.formData,
        isPreffered: action.payload.isPreffered
      };

    case CLOSE_HEADER_MODAL:
      return {
        ...state,
        [action.payload.modalType]: action.payload.actionValue
      };

    case EDIT_BOOKING_MODAL:
      return {
        ...state,
        editBookingModal: action.payload.editBookingModal
      };

    case CANCEL_BOOKING_MODAL:
      return {
        ...state,
        cancelBookingModal: action.payload.cancelBookingModal,
        cancelData: action.payload.cancelData
      };

    case OPEN_CURRENCY_MODAL:
      return {
        ...state,
        currencyModal: action.payload.currencyModal,
      };

    case IMAGE_LIGHTBOX_OPEN:
      return {
        ...state,
        imageLightBox: action.imageLightBox,
        currentIndex: action.currentIndex
      };

    case IMAGE_LIGHTBOX_CLOSE:
      return {
        ...state,
        imageLightBox: action.imageLightBox
      };

    case OPEN_DESCRIPTION_MODAL:
      return {
        ...state,
        jobDescriptionModal: action.payload.jobDescriptionModal,
        jobDescriptionData: action.payload.jobDescriptionData
      };

    case CLOSE_DESCRIPTION_MODAL:
      return {
        ...state,
        jobDescriptionModal: action.payload.jobDescriptionModal,
        jobDescriptionData: null
      };

    case CANCEL_SCHEDULED_BOOKING_MODAL:
      return {
        ...state,
        cancelScheduledBookingModal: action.payload.cancelScheduledBookingModal,
        cancelData: action.payload.cancelData
      };

    case OPEN_SCHEDULED_BOOKING_MODAL:
      return {
        ...state,
        scheduleBookingModal: action.payload.scheduleBookingModal
      };

    case CLOSE_SCHEDULED_BOOKING_MODAL:
      return {
        ...state,
        scheduleBookingModal: action.payload.scheduleBookingModal
      };

    case OPEN_BASE_FARE_MODAL:
      return {
        ...state,
        baseFareModal: action.payload.baseFareModal,
        title: action.payload.title
      }

    case CLOSE_BASE_FARE_MODAL:
      return {
        ...state,
        baseFareModal: action.payload.baseFareModal
      }

    case TOGGLE_ADMIN_MENU:
      return {
        ...state,
        isOpenAdminMenu: action.payload.isOpenAdminMenu,
      };

    case OPEN_PROVIDER_APPROVAL_MODAL:
      return {
        ...state,
        providerApprovalModal: action.payload.providerApprovalModal,
        providerApprovalData: action.payload.providerApprovalData
      }

    case CLOSE_PROVIDER_APPROVAL_MODAL:
      return {
        ...state,
        providerApprovalModal: action.payload.providerApprovalModal,
        providerApprovalData: null
      }


    default:
      return {
        ...state,
      };
  }
}
